export class BusinessRuleTypeModel {
    BusinessRuleTypeAPI: any;
  BusinessRuleTypeByID: any;
  UpdateBusinessRuleTypeAPI: any;
  DeleteBusinessRuleTypeID: any;



}
